import React from 'react';

const TableRow = ({ children }) => <div className="table_row">{children}</div>;

export default TableRow;
